import { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";

const type = Symbol("Sortable");

interface Swappable {
  order: number;
  swapItems: (a: number, b: number) => void;
}

interface Item {
  type: string;
  order: number;
}

const useSortable = ({ order = 0, swapItems }: Swappable) => {
  const ref = useRef(null);

  const [{ opacity }, drag] = useDrag({
    item: { type, order },
    collect: monitor => ({
      opacity: monitor.isDragging() ? 0.4 : 1
    })
  });

  const [, drop] = useDrop({
    accept: type,
    drop({ order: otherOrder }: Item) {
      // Don't replace items with themselves
      if (otherOrder === order) return;

      swapItems(otherOrder, order);
    }
  });

  drag(drop(ref));

  return { ref, opacity };
};
export default useSortable;
